require('!style-loader!css-loader!postcss-loader!stylus-loader!./markdownwrapper.styl');

var marked = require('marked');

marked.setOptions({
    renderer: new marked.Renderer(),
    gfm: true,
    tables: true,
    breaks: false,
    pedantic: false,
    sanitize: false,
    smartLists: true,
    smartypants: false
});

function parse(text, next) {

    // delete creating em/strong tags by wrapping with underlines (conflicts with the input-module), this can still be done using * and **
    marked.InlineLexer.rules.normal.strong = /^\*\*([\s\S]+?)\*\*(?!\*)/;
    marked.InlineLexer.rules.normal.em = /^\*((?:\*\*|[^\]\[])+?)\*(?!\*)/;
    marked.InlineLexer.rules.normal.escape = /^\\([\\`*{}()#+\-.!>])/;

    marked.InlineLexer.rules.gfm.strong = marked.InlineLexer.rules.normal.strong;
    marked.InlineLexer.rules.gfm.em = marked.InlineLexer.rules.normal.em;
    marked.InlineLexer.rules.gfm.escape = marked.InlineLexer.rules.normal.escape;

    var html = marked(text); //markdown.toHTML(text);
    next(html);

};

module.exports = {
    parse: parse
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/markdownwrapper/markdownwrapper.js